import { StatisticalAnalysisViewDetailChartTypeChartsFactory } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory'
import { initialStatisticalAnalysisViewDetailChartTypeChartsState, StatisticalAnalysisViewDetailChartTypeChartsModel, StatisticalAnalysisViewDetailChartTypeChartsState, StatisticalAnalysisViewDetailChartTypeChartsTypes } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts.model'
import { Options } from 'highcharts'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisViewDetailChartTypeCharts extends Vue {
    @Prop() readonly typeChartSelection!: StatisticalAnalysisViewDetailChartTypeChartsTypes
    @Prop() readonly chartOptions!: Options

    @Emit()
    selectedTypeChart(newChart: StatisticalAnalysisViewDetailChartTypeChartsTypes): StatisticalAnalysisViewDetailChartTypeChartsTypes {
        return newChart
    }
    @Emit()
    updateTypeChart(newChart: Options): Options {
        return newChart
    }

    state: StatisticalAnalysisViewDetailChartTypeChartsState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisViewDetailChartTypeChartsState(
            this.typeChartSelection ?? StatisticalAnalysisViewDetailChartTypeChartsTypes.COLUMN)
    }

    get isLoading(): boolean {
        return this.state.loading
    }

    get isSidepanelVisible(): boolean {
        return this.state.sidepanelVisible
    }

    created() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    onClick(chart: StatisticalAnalysisViewDetailChartTypeChartsModel): void {
        this.state.selected = chart.id
    }

    onApply(): void {
        if (this.typeChartSelection !== this.state.selected) {
            this.selectedTypeChart(this.state.selected)
            this.updateTypeChart(this._transformChart())
        }
        this.onCloseSidepanel()
    }

    onOpenSidepanel(): void {
        this.state.sidepanelVisible = true
    }

    onCloseSidepanel():void {
        this.state.sidepanelVisible = false
    }

    private _transformChart(): Options {
        return StatisticalAnalysisViewDetailChartTypeChartsFactory.getTypeChart(this.state.selected, this.chartOptions)
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.loading = value
    }
}
